import './menu-toggle.css';
export default {
  "avatar": "pf-v6-c-avatar",
  "button": "pf-v6-c-button",
  "check": "pf-v6-c-check",
  "checkInput": "pf-v6-c-check__input",
  "menuToggle": "pf-v6-c-menu-toggle",
  "menuToggleButton": "pf-v6-c-menu-toggle__button",
  "menuToggleControls": "pf-v6-c-menu-toggle__controls",
  "menuToggleCount": "pf-v6-c-menu-toggle__count",
  "menuToggleIcon": "pf-v6-c-menu-toggle__icon",
  "menuToggleStatusIcon": "pf-v6-c-menu-toggle__status-icon",
  "menuToggleText": "pf-v6-c-menu-toggle__text",
  "menuToggleToggleIcon": "pf-v6-c-menu-toggle__toggle-icon",
  "modifiers": {
    "primary": "pf-m-primary",
    "secondary": "pf-m-secondary",
    "fullHeight": "pf-m-full-height",
    "fullWidth": "pf-m-full-width",
    "plain": "pf-m-plain",
    "expanded": "pf-m-expanded",
    "disabled": "pf-m-disabled",
    "small": "pf-m-small",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "danger": "pf-m-danger",
    "settings": "pf-m-settings",
    "placeholder": "pf-m-placeholder",
    "splitButton": "pf-m-split-button",
    "standalone": "pf-m-standalone",
    "typeahead": "pf-m-typeahead",
    "text": "pf-m-text",
    "avatar": "pf-m-avatar"
  },
  "textInputGroup": "pf-v6-c-text-input-group"
};